import { useState } from "react";
import { Lock, Loader2, LogIn } from "lucide-react";

export const AdminLoginForm = ({ title, subtitle, onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await onLogin(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-screen" className="min-h-screen bg-rr-navyDeep flex items-center justify-center px-5">
      <form onSubmit={submit} className="bg-white rounded-2xl p-8 max-w-sm w-full shadow-2xl">
        <div className="w-12 h-12 rounded-xl bg-rr-orange/10 text-rr-orange flex items-center justify-center mb-5">
          <Lock size={20} />
        </div>
        <h1 className="font-heading text-xl font-bold text-rr-navy">{title}</h1>
        <p className="text-sm text-rr-muted mt-1.5">{subtitle}</p>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Admin email"
          data-testid="admin-login-email-input"
          className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm mt-5 focus:outline-none focus:border-rr-orange"
        />
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          data-testid="admin-login-password-input"
          className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm mt-3 focus:outline-none focus:border-rr-orange"
        />
        {error && <p data-testid="admin-login-error" className="text-xs text-rr-red mt-2 font-bold">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit-button"
          className="w-full bg-rr-navy text-white font-bold py-3 rounded-full mt-4 hover:bg-rr-orange transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <><LogIn size={16} /> Sign In</>}
        </button>
      </form>
    </div>
  );
};
